import {  Injectable  } from '@angular/core';
import {  Roles       } from '../../../../model/variables';

export interface NavigationItem
{
  id            : string;
  title         : string;
  type          : 'item' | 'collapse' | 'group';
  translate?    : string;
  icon?         : string;
  hidden?       : boolean;
  url?          : string;
  classes?      : string;
  exactMatch?   : boolean;
  external?     : boolean;
  target?       : boolean;
  breadcrumbs?  : boolean;
  function?     : any;
  permisos?     : Array<string>,
  children?     : Navigation[];
  badge?        : {
                    title?  : string;
                    type?   : string;
                  };
}

export interface Navigation extends NavigationItem
{
  children? : NavigationItem[];
}

const NavigationItems =
[
  {
    id        : 'navigation',
    title     : 'Menú',
    type      : 'group',
    icon      : 'feather icon-align-left',
    permisos  : [ Roles.admin, Roles.coordinador, Roles.tecnico, Roles.empleado ],
    children  : [
      {
        id        : 'configuracion',
        title     : 'Configuración',
        type      : 'collapse',
        icon      : 'feather icon-menu',
        permisos  : [ Roles.admin, Roles.coordinador, Roles.tecnico ],
        children  : [
          {
            id        : 'categorias',
            title     : 'Categorías',
            type      : 'item',
            url       : '/configuracion/categorias',
            permisos  : [ Roles.admin, Roles.coordinador ],
          },
          {
            id        : 'nivelesServicio',
            title     : 'Niveles de servicio',
            type      : 'item',
            url       : '/configuracion/nivelesServicio',
            permisos  : [ Roles.admin, Roles.coordinador ],
          },
          {
            id        : 'servicios',
            title     : 'Servicios',
            type      : 'item',
            url       : '/configuracion/servicios',
            permisos  : [ Roles.admin, Roles.coordinador, Roles.tecnico ],
          },
          {
            id        : 'admonZona',
            title     : 'Admon. zona',
            type      : 'item',
            url       : '/configuracion/admonZona',
            permisos  : [ Roles.tecnico ],
          },
        ]
      },
      {
        id        : 'listado',
        title     : 'Listado de solicitudes',
        type      : 'item',
        url       : '/solicitudes/listado',
        icon      : 'feather icon-sidebar',
        permisos  : [ Roles.admin, Roles.coordinador, Roles.tecnico, Roles.empleado ],
        // children  : [
        //   {
        //     id        : 'listado',
        //     title     : 'Listado de Solicitudes',
        //     type      : 'item',
        //     url       : '/solicitudes/listado',
        //     permisos  : [ Roles.admin, Roles.coordinador, Roles.tecnico, Roles.empleado ],
        //   },
        // ]
      },
      {
        id        : 'reportes',
        title     : 'Reportes',
        type      : 'collapse',
        icon      : 'feather icon-info',
        permisos  : [ Roles.admin ],
        children  : [
          {
            id        : 'incidenciasXestatus',
            title     : 'Incidencias por Estatus',
            type      : 'item',
            url       : '/reportes/incidenciasXestatus',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'incidenciasXpersonasServicios',
            title     : 'Incidencias por Personas de Servicio',
            type      : 'item',
            url       : '/reportes/incidenciasXpersonasServicios',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'serviciosAtendidos',
            title     : 'Servicios Atendidos',
            type      : 'item',
            url       : '/reportes/serviciosAtendidos',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'serviciosXniveles',
            title     : 'Incidencias por Niveles de Servicio',
            type      : 'item',
            url       : '/reportes/serviciosXniveles',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'sabanaCompletaExcel',
            title     : 'Reporte Completo en Excel',
            type      : 'item',
            url       : '/reportes/sabanaCompletaExcel',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'origenCierreTickets',
            title     : 'Comparativo de cierre de tickets',
            type      : 'item',
            url       : '/reportes/origenCierreTickets',
            permisos  : [ Roles.admin ],
          },
        ]
      },
      {
        id        : 'dashboard',
        title     : 'Dashboard',
        type      : 'collapse',
        icon      : 'feather icon-bar-chart-2',
        permisos  : [ Roles.admin ],
        children  :
        [
          {
            id        : 'dashboard-monitoreo',
            title     : 'Dashboard de Monitoreo',
            type      : 'item',
            url       : '/dashboard/dashboard-monitoreo',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'dashboard-solicitudes',
            title     : 'Dashboard de Solicitudes',
            type      : 'item',
            url       : '/dashboard/dashboard-solicitudes',
            permisos  : [ Roles.admin ],
          }
        ]
      },
      {
        id        : 'agentes',
        title     : 'Agentes',
        type      : 'collapse',
        icon      : 'feather icon-users',
        permisos  : [ Roles.admin ],
        children  : [
          {
            id        : 'personas-servicios',
            title     : 'Personas en Servicios',
            type      : 'item',
            url       : '/agentes/personas-servicios',
            permisos  : [ Roles.admin ],
          },
          {
            id        : 'personas-servicio-municipio',
            title     : 'Persona en Servicio por Municipio',
            type      : 'item',
            url       : '/agentes/personas-servicio-municipio',
            permisos  : [ Roles.admin ]
          },
          {
            id        : 'encargados-personas',
            title     : 'Encargados por Personas',
            type      : 'item',
            url       : '/agentes/encargados-personas',
            permisos  : [ Roles.admin ],
          },
          {
            id: 'usuarios',
            title: 'Usuarios prioritarios',
            type: 'item',
            url: '/usuarios/usuarios-prioritarios',
            classes: 'nav-item',
            // icon: 'feather icon-user',
            permisos: [ Roles.admin ],
          },
        ]
      },
    ]
  }
];

@Injectable()
export class NavigationItem
{
  public get()
  {
    return NavigationItems;
  }
}
